<template>
  <div>

    <widget title="Yönetici Giriş Sayfası" v-if="$root.checkRole(['ROLE_ADMIN'])">
      <address-select></address-select>
    </widget>
    <widget title="Bayi Giriş Sayfası" v-if="$root.checkRole(['ROLE_DEALER'])">

    </widget>
    <widget title="Ödeme Noktası Giriş Sayfası" v-if="$root.checkRole(['ROLE_POINT'])">

    </widget>
    <widget title="Müşteri Girişi" v-if="$root.checkRole(['ROLE_CUSTOMER'])">

    </widget>


  </div>
</template>
<script>
  export default {
    name: 'Home',
    data() {
      return {}
    },
    created() {

    },
    methods: {}
  }
</script>


<style lang="scss">
  /**
    .orgchart-container {
      min-height: 1000px !important;
      background-color: #efefef;
    }

    $color: rgba(41, 128, 185, 0.8);
    .downLine {
      background-color: $color !important;
    }

    .leftLine {
      border-left: 1px solid $color !important;
    }

    .rightLine {
      border-right: 1px solid $color !important;
    }

    .topLine {
      border-top: 2px solid $color !important;
    }

    .oc-node {
      border: 1px solid $color;
      border-radius: 10px;
      padding: 10px;
      background: #FFF;
      min-height: 150px;
      position: relative;

      h2 {

        font-size: 12px;
        padding: 0;
        margin: 2px;
        display: block;
      }

      p {
        margin: 10px;
        width: calc(100% - 20px);
        border: 1px solid #a0a0a0;
        border-radius: 10px;
        font-size: 9px;
        padding: 5px;
        position: absolute;
        bottom: 2px;
        left: 0;
      }

    }

    .orgchart {

      background-image: none !important;
      width: 175px !important;
    }


   */
</style>



// WEBPACK FOOTER //
// src/components/Base/Home.vue